import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { EnsureHttpsPipe } from '@pipes/ensure-https.pipe';
import { EditorComponentBase, IconSanitizerService } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-link-editor',
    templateUrl: './link-editor.component.html',
    styleUrls: ['./link-editor.component.scss'],
    imports: [FormsModule, ValidationErrorMessageComponent, EnsureHttpsPipe]
})
export class LinkEditorComponent extends EditorComponentBase<string> {
    private readonly iconSanitizer = inject(IconSanitizerService);
    profileIcon: SafeHtml = this.iconSanitizer.getIcon('profile');
    websiteIcon: SafeHtml = this.iconSanitizer.getIcon('website');

    constructor() {
        super();
    }

    dataChanged() {
        this.validate();
    }
}
